// extracted by mini-css-extract-plugin
module.exports = {"container":"loading_container_container__3g6vN","overlayText":"loading_container_overlayText__1DFaS"};